// The base IP address of the wireless access point's HTTP API.
export const BASE_IPV4_ADDRESS = 'https://172.17.2.1';
export const EVSE_API_USERNAME = 'sehome';
export const EVSE_FACTORY_PIN_CODE = '123456';

// During onboarding, EVSE Soft-AP can take up to 2 minutes to become stably reachable.
export const EVSE_AP_READY_MAX_WAIT_MS = 2 * 60 * 1000;
export const EVSE_AP_INITIAL_CONNECT_DELAY_MS = 10_000;
export const EVSE_AP_RECONNECT_INTERVAL_MS = 10_000;

// EVSE device reboot time after Wi-Fi configuration
export const EVSE_REBOOT_TIMEOUT_MS = 12_000;

export const HISTORY_CHART_OPTIONS = {
  height: 320,
  color: '#9B51E0',
  fillGradientStart: 'rgba(155, 81, 224, 0.3)',
  fillGradientStop: 'rgba(155, 81, 224, 0)',
};

export const DAY_RESET_ZOOM_ANIM_MS = 400;

export const COLOR_INDICATOR_AVAILABLE = '#009530';
export const COLOR_INDICATOR_AVAILABLE_DARK = '#3DCD57'; // dark mode variant
export const COLOR_INDICATOR_DEFAULT = '#0087CD';
export const COLOR_INDICATOR_DEFAULT_DARK = '#42B4E6'; // dark mode variant
export const COLOR_INDICATOR_DEFAULT_DARK_DIM = 'rgba(66, 180, 230, 0.1)'; // dims COLOR_INDICATOR_DEFAULT_DARK
export const COLOR_INDICATOR_ERROR = '#BA3430';
export const COLOR_INDICATOR_OFFLINE = '#FEDC38'; // amber/yellow — charger is offline/unavailable
export const COLOR_INDICATOR_FW_UPDATE = '#FFD100'; // amber/yellow — firmware update in progress
export const COLOR_INDICATOR_FW_UPDATE_DIM = 'rgba(255, 209, 0, 0.1)'; // dims COLOR_INDICATOR_FW_UPDATE
export const COLOR_INDICATOR_FW_UPDATE_DARK = '#FEDC38'; // dark mode variant — firmware update in progress
export const COLOR_INDICATOR_FW_UPDATE_DARK_DIM = 'rgba(254, 220, 56, 0.1)'; // dims COLOR_INDICATOR_FW_UPDATE_DARK
export const COLOR_INDICATOR_UNAVAILABLE = '#9FA0A3';
export const COLOR_INDICATOR_SLOWED = '#E47F00'; // orange - SmartPlug power cord while charging is slowed

export const UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

// ─── Charger-status transition timing (smooth home-screen transitions) ───────
// Snappy feel (~0.4s). Distinct from CYCLE_COLOR_TRANSITION (0.8s) which drives
// the in-phase cycling pulse and must keep its own cadence.
export const STATUS_COLOR_TRANSITION = 'fill 0.4s ease-in-out';
export const PORT_FADE_DURATION_S = 0.25; // car-port pins fade in/out
// The car body colour wipes radially from the charging port, as if the cable is
// energising the charger. Deliberately slow so the sweep is clearly visible.
export const COLOR_WIPE_DURATION_S = 1.1;
// Charging port location in the EV's 320×290 viewBox (centre of the port lid),
// and the radius the colour wipe must reach to cover the whole car from there.
export const EV_PORT_POINT = { x: 196, y: 128 };
export const EV_WIPE_MAX_RADIUS = 340;
// ─── Physical plug animation ─────────────────────────────────────────────────
// The cable physically morphs between its coiled, unplugged resting shape and the
// connected curve to the car port — no fading, pure geometric motion.
export const PLUG_ANIM_DURATION_MS = 400; // cable morph time, point A → B
